import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  DeviceDTO,
  ProblemType,
} from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'PlantDevicesAnomaly',
  props: {
    device: {
      type: Object as PropType<DeviceDTO>,
      required: true,
    },
  },
})
export default class PlantDevicesAnomaly extends Vue {
  device!: DeviceDTO;
  
  get anomalySeverity() {
    if (this.device.isBlocking) return 'warn';
    return 'error';
  }

  get anomalyDescription() {
    switch (this.device.problemType) {
      case ProblemType.None:
        return this.$t('AppResource.Noproblem').toString();

      case ProblemType.PhisicallyConfigured:
        return this.$t('AppResource.Devicephysicallyconfigured').toString();

      case ProblemType.DeviceRemoved:
        return this.$t('AppResource.Deviceremoved').toString();

      case ProblemType.DeviceUnmanage:
        return this.$t('AppResource.Devicenotmanaged').toString();

      case ProblemType.DeviceChanged:
        return this.$t('AppResource.DeviceAlreadyConfigured').toString();
    }
  }
}
